module.exports = __webpack_public_path__ + "img/arrow-right-2-w.d961ed1d.svg";